module.exports = __webpack_public_path__ + "img/avatar-user.ee34a41d.png";